import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';
import {reverseShortDate} from '../../common/constants/datesFormat';
import moment from 'moment';

/* export const restoreEtaManagementFilters = () => ({
  'type': ActionTypes.RESTORE_DEALER_ORDERS_ETA_MANAGEMENT,
}); */

export const getEtaManagementData = (filters = {}) => apiActionCreator({
  'endpoint': `/orders/eta-management${getUrlParameters({
    ...filters,
    'dateFrom': filters?.dateFrom ? moment(filters?.dateFrom).format(reverseShortDate) : filters.dateFrom,
    'dateTo': filters?.dateTo ? moment(filters?.dateTo).format(reverseShortDate) : filters.dateTo,
  })}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_REQUEST,
    [
      ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_SUCCESS,
    ],
    [
      ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getEtaManagementDetail = (code) => apiActionCreator({
  'endpoint': `/orders/eta-management/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_REQUEST,
    [
      ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_SUCCESS,
    ],
    [
      ActionTypes.GET_DEALER_ORDERS_ETA_MANAGEMENT_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const editEtasManagementFilters = (field, value) => ({
  'type': ActionTypes.EDIT_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS,
  'payload': {'field': field, 'value': value},
});

export const cleanEtasManagementFilters = () => ({
  'type': ActionTypes.CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_FILTERS,
});

export const cleanEtasManagementData = () => ({
  'type': ActionTypes.CLEAN_DEALER_ORDERS_ETA_MANAGEMENT_DATA,
});

export const updateProviderInvoiceStep = (orderSequence, data, filters, setShowFechaFacturaModal) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/orders/dealers/tracking/${orderSequence}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATE_ORDER_TRACKING_STEP_REQUEST,
        [
          () => {
            dispatch(getEtaManagementData(filters));
            return {
              'type': ActionTypes.UPDATE_ORDER_TRACKING_STEP_SUCCESS,
            };
          },
          (response) => buildSuccessMessage(response, 'Información subida satisfactoriamente'),
          () => setShowFechaFacturaModal(null),
        ],
        [
          ActionTypes.UPDATE_ORDER_TRACKING_STEP_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
